import { getSubscriptionDetails } from "./actions";
import types from "./types";

const initialState = {
  subscriptionPlan: {},
  getTestimonalData: {},
  getSubscriptionDetails: {},
  getSubscriptionPaymentDetails: {},
  getDrowngradeDetailRes: {},
};

const subscription = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SUBSCRIPTION_RESP:
      return {
        ...state,
        subscriptionPlan: action.payload,
      };
    case types.GET_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        subscriptionPlan: {},
      };
    case types.GET_TESTIMONAL_RESP:
      return {
        ...state,
        getTestimonalData: action.payload,
      };
    case types.GET_TESTIMONAL_CLEAR:
      return {
        ...state,
        getTestimonalData: {},
      };
    case types.GET_SUBSCRIPTION_DETAILS_RESP:
      return {
        ...state,
        getSubscriptionDetails: action.payload,
      };
    case types.GET_SUBSCRIPTION_DETAILS_CLEAR:
      return {
        ...state,
        getSubscriptionDetails: {},
      };
    case types.GET_SUBSCRIPTION_PAYMENT_DETAILS_RESP:
      return {
        ...state,
        getSubscriptionPaymentDetails: action.payload,
      };
    case types.GET_SUBSCRIPTION_PAYMENT_DETAILS_CLEAR:
      return {
        ...state,
        getSubscriptionPaymentDetails: {},
      };
    case types.GET_DROWNGRADE_REQUEST_RESP:
      return {
        ...state,
        getDrowngradeDetailRes: action.payload,
      };
    case types.GET_DROWNGRADE_REQUEST_CLEAR:
      return {
        ...state,
        getDrowngradeDetailRes: {},
      };  
    default:
      return state;
  }
};

export default subscription;
